export default __webpack_public_path__ + "static/media/5.367fed49.jpg";